import { render, staticRenderFns } from "./input-select-many.vue?vue&type=template&id=2854d392&"
import script from "./input-select-many.component.ts?vue&type=script&lang=ts&"
export * from "./input-select-many.component.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports